import React from "react";

const getConfidenceStyle = (confidence) => {
    if (confidence >= 0.8) return { bg: "bg-success", label: "High confidence" };
    if (confidence >= 0.5) return { bg: "bg-warning text-dark", label: "Medium confidence" };
    return { bg: "bg-danger", label: "Low confidence" };
};

const ConfidenceBadge = ({ confidence }) => {
    const numeric = Number(confidence);
    if (confidence === null || confidence === undefined || Number.isNaN(numeric)) {
        return <span className="badge bg-secondary rounded-pill">N/A</span>;
    }

    const percent = Math.round(numeric * 100);
    const { bg, label } = getConfidenceStyle(numeric);

    return (
        <span className={`badge rounded-pill ${bg}`} title={label}>
            {percent}%
        </span>
    );
};

export default ConfidenceBadge;
